import Vue from "vue";
import Vuetify from "vuetify/lib";
import en from 'vuetify/es5/locale/en'
import de from 'vuetify/es5/locale/de'
import 'material-design-icons-iconfont/dist/material-design-icons.css';

function loadStoredLanguage()
{
  let lang = localStorage.getItem('kisme.lang');
  if(lang == null)
  {
    lang = 'en';
  }
  return lang;
}

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: false,
    themes: {
      light: {
        rafiGreen: "#A9C938",
        rafiOrange: "#FFA626",
        headerBackground: "#f2eeef",
        petrol: "#00ADBA",
        oceanblau: "#003546",
        anthrazit: "#31383B",
        background: "#FFFFFF",
        content: "#FFFFFF",
        licenceTitleBackground: "#32373e",
        licenceContentBackground: "#D9D8DA",
        licenceDeviceBackground: "#807F80",
        greytext: "#797979"
      },
      dark: {
        headerBackground: "#f2eeef",
        petrol: "#00ADBA",
        oceanblau: "#003546",
        anthrazit: "#31383B",
        background: "#003546",
        content: "#00ADBA",
        licenceTitleBackground: "#32373e",
        licenceContentBackground: "#D9D8DA",
        licenceDeviceBackground: "#807F80",
        greytext: "#797979"
      },
    },
  },
  lang: {
    locales: { en, de },
    current: loadStoredLanguage(),
  }
};

export default new Vuetify(opts);
